// test2447
(2447 && 0);
